import React, { useState, useEffect } from "react";
import Styles from "./ProductCard.module.scss";
import { ReactComponent as DiscountSVG } from "../../../imges/DiscountIcon.svg";
import useCurrency from "../../../yoello-lib/modules/localisation/useCurrency";
import T from "i18n-react";
import { IProductCardProps } from "./types";

const ProductCard = ({ productInfo, onClick }: IProductCardProps) => {
  const [price, setPrice] = useState<number>(null);
  const { formatCurrency } = useCurrency();
  const formattedPrice = formatCurrency(price);
  useEffect(() => {
    if (checkPricingOptions() === true) {
      const menuPrice = productInfo.menu_item_pricing_options;
      const key = Object.keys(menuPrice)[0];

      setPrice(menuPrice[key].option_price);
    }
    // eslint-disable-next-line
  }, []);

  function checkPricingOptions() {
    const priceOps = productInfo.menu_item_pricing_options;
    if (priceOps !== null || priceOps !== undefined) {
      if (typeof priceOps === "object" && Object.keys(priceOps).length > 0) {
        return true;
      }
    }
    return false;
  }
  function getOff(info) {
    let flag = false;
    if (info.menu_item_pricing_options) {
      Object.keys(info.menu_item_pricing_options).forEach((item, i) => {
        if (info.menu_item_pricing_options[item].option_discount > 0) {
          flag = true;
        }
      });
    }

    return flag;
  }

  if (productInfo) {
    return (
      <div
        data-component-name="ProductCard"
        className={`${Styles.ProductCard} ${
          productInfo.menu_item_enabled ? "" : Styles.ProductCardDisabled
        }`}
        onClick={() => {
          if (productInfo.menu_item_enabled && checkPricingOptions()) {
            onClick();
          }
        }}
      >
        {getOff(productInfo) ? (
          <div className={Styles.DiscountIcon}>
            <DiscountSVG height="22px" width="22px" />
          </div>
        ) : null}

        {productInfo.menu_item_url_photo && (
          <div>
            <div
              style={{
                position: "relative",
                height: "100%",
              }}
            >
              <div className={Styles.cardImage}>
                <img src={productInfo.menu_item_url_photo} alt="" />
              </div>
            </div>
          </div>
        )}

        <div
          className={`${Styles.productDetails} ${
            !productInfo.menu_item_description ? Styles.flexDirecton : null
          }`}
          style={
            productInfo.menu_item_url_photo
              ? { width: "calc(100% - 68px)" }
              : { width: "100%" }
          }
        >
          <div>
            <p
              data-component-name="ProductCardTitle"
              data-menu-item={productInfo.menu_item_name_public}
              className={Styles.Title}
            >
              {productInfo.menu_item_name_public}
            </p>
          </div>
          <div>
            <div>
              {productInfo.menu_item_description && (
                <p className={Styles.Description}>
                  {productInfo.menu_item_description}
                </p>
              )}
              {!productInfo.menu_item_enabled ? (
                <T.p
                  className={Styles.OutOfStuckText}
                  text={{ key: `Errors.OutOfStock` }}
                />
              ) : null}
            </div>
            <div>
              {productInfo.menu_item_enabled &&
              checkPricingOptions() &&
              price !== undefined &&
              price !== null ? (
                <p
                  data-component-name="ProductCardPrice"
                  className={`${Styles.CurrentPrice}  m-0`}
                >
                  {formattedPrice}
                </p>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return <div></div>;
  }
};

export default React.memo(ProductCard);
